import { api } from "@/lib/api";
import { Vessel, ApiResponse } from "@/lib/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useGetVessels = (
  options?: Omit<UseQueryOptions<ApiResponse<Vessel[]>>, "queryKey" | "queryFn">
) => {
  return useQuery<ApiResponse<Vessel[]>>({
    queryKey: ["vessels"],
    queryFn: async () => {
      const response = await api.get("/vessels");
      return response.data;
    },
    ...options,
  });
};

export const useGetVesselById = (
  id?: string,
  options?: Omit<UseQueryOptions<ApiResponse<Vessel>>, "queryKey" | "queryFn">
) => {
  return useQuery<ApiResponse<Vessel>>({
    queryKey: ["vessel-detail", id],
    queryFn: async () => {
      const response = await api.get(`/vessels/${id}`);
      return response.data;
    },
    enabled: !!id,
    ...options,
  });
};
